import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { containsProductCategory, isProductCategoryFernwaerme } from '@mwe/utils';
import { ProductCategoryEnum } from '@mwe/constants';
import { AlertComponent } from '../../alert/alert.component';
import { NgClass } from '@angular/common';
import { InfoboxComponent } from '../../infobox/infobox.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-new-bank-account-info-texts',
  templateUrl: './new-bank-account-info-texts.component.html',
  imports: [AlertComponent, NgClass, InfoboxComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewBankAccountInfoTextsComponent {
  // todo remove me once every parent has same design
  useTemplate = input<'alert' | 'info-box'>('alert');
  hasSpotTariff = input<boolean>(false);
  productCategories = input<string[]>([]);

  private rawIsStrom = computed(() =>
    this.productCategories().some(category =>
      containsProductCategory(category, [ProductCategoryEnum.STROM, ProductCategoryEnum.NACHTSTROM]),
    ),
  );

  isGasInfoVisible = computed(() =>
    this.productCategories().some(category => containsProductCategory(category, [ProductCategoryEnum.GAS])),
  );

  isFernwaermeInfoVisible = computed(() => this.productCategories().some(category => isProductCategoryFernwaerme(category)));

  isStromInfoVisible = computed(() => this.rawIsStrom() && !this.hasSpotTariff());

  isStromSpotInfoVisible = computed(() => this.rawIsStrom() && this.hasSpotTariff());

  isStromGasInfoVisible = computed(() => this.isStromInfoVisible() && this.isGasInfoVisible());
}
